import { useCallback, useRef } from 'react';

/**
 * Hook that manages the prerenderReady flag for Puppeteer pre-rendering.
 * Dynamic pages (BlogDetails, EmptyLegDetails) call markReady() after API data loads.
 *
 * Static pages (Home, AboutUs, etc.) should NOT import this hook.
 * They are ready immediately — window.prerenderReady stays undefined,
 * which Puppeteer treats as ready.
 *
 * WARNING: If you use this hook, you MUST call markReady() or Puppeteer
 * will wait 10s for prerenderReady to become true before timing out.
 */
const usePrerenderReady = () => {
  const marked = useRef(false);

  // Set flag to false on first use (Puppeteer will wait for it to become true)
  if (typeof window !== 'undefined' && window.prerenderReady === undefined) {
    window.prerenderReady = false;
  }

  const markReady = useCallback(() => {
    if (!marked.current) {
      marked.current = true;
      window.prerenderReady = true;
    }
  }, []);

  return { markReady };
};

export default usePrerenderReady;
